const permissionTypes =  {
    ADD_CONTENT_TO_PAGE: "addContentToPage",
    ADD_PAGE: "addPage",
    ADMIN_PAGE: "adminPage",
    COPY_PAGE: "copyPage",
    DELETE_PAGE: "deletePage",
    EXPORT_PAGE: "exportPage",
    IMPORT_PAGE: "importPage",
    MANAGE_PAGE: "managePage"
};

export default permissionTypes;